import { createContext, useContext } from "react";

export const ProfileContext = createContext({
  profile: {},
  setProfile: () => {},
});
export const useProfileContext = () => useContext(ProfileContext);
